import { useState as m, useEffect as r } from "react";
import { b as u, S as e, c as p } from "../base-BUIxijjU.js";
import { getApiLink as l } from "../core/utils/url.js";
import "react/jsx-runtime";
import "../index-C7ezJk5b.js";
import "react-dom";
import '../assets/Wrapper.css';/* empty css                  */
import "react-router-dom";
function x(s) {
  const i = u(), { globalSearch: { query: a } } = i, [n, o] = m(new e()), t = p({
    url: l("/api/Data/Autosuggest", { q: a }),
    method: "GET",
    lazy: !a.trim() || !s
  });
  return r(() => {
    !t.isLoading && t.data ? o(new e({
      apiModel: t.data,
      platformContextValue: i
    })) : o(new e());
  }, [t.isLoading, t.data]), r(() => {
    a.trim() || o(new e());
  }, [a]), {
    isLoading: t.isLoading,
    data: n
  };
}
export {
  x as usePlatformSearch
};
